import React from "react";
import {
  FaShareAlt,
  FaArrowRight,
  FaStar,
  FaRegClock,
  FaGlobe,
} from "react-icons/fa";

export default function IENewsCard({ item }) {

  // =========================================================
  // CONVERT FIRESTORE TIMESTAMP TO "TIME AGO"
  // =========================================================

  const timeAgo = (timestamp) => {

    if (!timestamp) return "";

    const date = timestamp.toDate
      ? timestamp.toDate()
      : new Date(timestamp);

    const seconds = Math.floor(
      (Date.now() - date.getTime()) / 1000
    );

    if (seconds < 60) {
      return "Just now";
    }

    const minutes = Math.floor(seconds / 60);

    if (minutes < 60) {
      return `${minutes} min${
        minutes > 1 ? "s" : ""
      } ago`;
    }

    const hours = Math.floor(minutes / 60);

    if (hours < 24) {
      return `${hours} hour${
        hours > 1 ? "s" : ""
      } ago`;
    }

    const days = Math.floor(hours / 24);

    if (days < 30) {
      return `${days} day${
        days > 1 ? "s" : ""
      } ago`;
    }

    return date.toLocaleDateString();
  };


  // =========================================================
  // SHARE NEWS
  // =========================================================

  const shareNews = () => {

    /*
     * IMPORTANT
     *
     * This is now the ONLY URL shared to WhatsApp.
     *
     * The original Google News URL from:
     *
     * item.newsUrl
     *
     * is NOT included in the WhatsApp message.
     */

    const shareUrl =
      "https://eyalmart.com/ie";


    // Clean title
    const title =
      item.title
        ?.replace(/\s-\s.*$/, "")
        ?.replace(/<[^>]*>/g, "")
        ?.trim() ||
      "Info Exchange";


    /*
     * Keep the WhatsApp message clean.
     *
     * No Google News URL.
     * No HTML.
     * Only Eyal Mart URL.
     */

    const shareText = `Info Exchange - 

${title}

Read more on Eyal Mart:
${shareUrl}`;


    // WhatsApp share URL

    const whatsappUrl =
      `https://wa.me/?text=${encodeURIComponent(
        shareText
      )}`;


    // Open WhatsApp

    window.open(
      whatsappUrl,
      "_blank",
      "noopener,noreferrer"
    );

  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <div className="ie-card">


      {/* =====================================================
          IMAGE
      ====================================================== */}

      {item.imageUrl && (

        <div className="ie-card-image">

          <img
            src={
              item.imageUrl ||
              "/images/news-placeholder.jpg"
            }
            alt={item.title || ""}
            onError={(e) => {
              e.target.src =
                "/images/news-placeholder.jpg";
            }}
          />


          {/* CATEGORY */}

          <div className="ie-category-badge">

            {item.category}

          </div>


          {/* FEATURED */}

          {item.featured && (

            <div className="ie-featured-badge">

              <FaStar />

              Featured

            </div>

          )}

        </div>

      )}


      {/* =====================================================
          CONTENT
      ====================================================== */}

      <div className="ie-card-body">


        {/* TITLE */}

        <h3 className="ie-title">

          {item.title?.replace(
            /\s-\s.*$/,
            ""
          )}

        </h3>


        {/* ===================================================
            SUMMARY
        ==================================================== */}

        {/*
        <p className="ie-summary">
          {item.summary}
        </p>
        */}


        {/* ===================================================
            META
        ==================================================== */}

        <div className="ie-meta">

          <span>

            <FaGlobe />

            {item.source}

          </span>


          <span>

            <FaRegClock />

            {timeAgo(item.createdAt)}

          </span>

        </div>


        {/* ===================================================
            ACTIONS
        ==================================================== */}

        <div className="ie-actions">


          {/* =================================================
              SHARE
          ================================================== */}

          <button
            type="button"
            className="share-btn"
            onClick={shareNews}
          >

            <FaShareAlt />

            Share

          </button>


          {/* =================================================
              READ MORE
          ================================================== */}

          <button
            type="button"
            className="read-btn"
            onClick={() =>
              window.open(
                item.newsUrl,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >

            Read More

            <FaArrowRight />

          </button>


        </div>

      </div>

    </div>

  );
}